import LcLoadingIndicator from "./LcLoadingIndicator";

export { LcLoadingIndicator };
export default LcLoadingIndicator;
